export const FREESHIPPING_COUPON_CODE = 'newfreeship';
